import React from 'react'
import { Link } from 'react-router-dom'

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-pale-slate-500/20 bg-indigo-velvet-800 px-6 py-8">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-4 sm:flex-row sm:justify-between">
        <Link to="/">
          <img src="/images/waypo-header.png" alt="Waypo" className="h-8" />
        </Link>

        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-pale-slate-500">
          <Link to="/about" className="hover:text-pale-slate-300 transition-colors">
            About
          </Link>
          <Link to="/guidelines" className="hover:text-pale-slate-300 transition-colors">
            Community Guidelines
          </Link>
          <Link to="/terms" className="hover:text-pale-slate-300 transition-colors">
            Terms of Service
          </Link>
          <Link to="/privacy" className="hover:text-pale-slate-300 transition-colors">
            Privacy Policy
          </Link>
          <a
            href="mailto:rick@waypo.tours"
            className="hover:text-pale-slate-300 transition-colors"
          >
            Contact
          </a>
        </nav>

        <p className="text-xs text-pale-slate-600">
          © {new Date().getFullYear()} Waypo
        </p>
      </div>
    </footer>
  )
}
